
import ElButton from "../../../../node_modules/element-ui/packages/button/src/button.vue";
import ElInput from "../../../../node_modules/element-ui/packages/input/src/input.vue";
import Loading from 'vux/src/components/loading/index.vue'


export default {
components: {
ElInput,
ElButton,
Loading
},
data() {
return {
loadText: '拼命加载中',
showLoading: false,
defaultValue:'',//是否默认
inquiryname:this.$route.query.type=='WZ'?"我的问诊单":"我的随访单",
wenzhendan:[
{
singleselection:'2',
isrequired:'1',

questionname:'',
options:[{
select:'',
}]
}
],
doctorId:'',//医生id
type:"",//问诊单1  随访单2
operate:'',//操作add增加 modify修改 query查询
id:'',//问诊单/随访单id
};
},
created() {
console.log(this.$store.state.userInfo.sessionId);
this.$store.state.userInfo.sessionId = 'haozhongyi';
this.doctorId=this.$route.query.doctorId?this.$route.query.doctorId:'';
this.id=this.$route.query.id?this.$route.query.id:'';
this.operate=this.$route.query.operate?this.$route.query.operate:'';
this.type=this.$route.query.type?this.$route.query.type:'';
document.title = this.type=='WZ'?"问诊单":"随访单";
this.query();


},
methods: {
JAMS__mark() {
if (/android/i.test(navigator.userAgent)) {
try {
window.android.JAMS__mark("1")
} catch (e) {
console.log(e)
}
} else if (/ios|iphone|ipod|pad/i.test(navigator.userAgent)) {
try {
window.webkit.messageHandlers.JAMS__mark.postMessage("1")
} catch (e) {
console.log(e)
}
}
},
add(i){
console.log('初始前',this.wenzhendan);
if(this.type=='WZ'&&this.wenzhendan.length>=40){
this.$toastMsg("问诊单题目最多40个");
return
}
if(this.type=='SF'&&this.wenzhendan.length>=20){
this.$toastMsg("随访单题目最多20个");
return
}
if(this.wenzhendan[i].questionname==''){
this.$toastMsg("请填写题目");
return
}
if(this.wenzhendan[i].singleselection!='3'&&this.wenzhendan[i].options.length<2){
this.$toastMsg("第"+(i+1)+"个题目选项小于两个。");
return;
}
if(this.wenzhendan[i].singleselection!='3'&&this.wenzhendan[i].options[this.wenzhendan[i].options.length-1].select==''){
this.$toastMsg("第"+(i+1)+"个题目答案待核查");
return;
}
this.wenzhendan.splice(i+1,0, {
isrequired:'1',
singleselection:'2',
questionname:'',
options:[{
select:''
}]
}
);
$("#textBtn").focus();
},
addd(index,inde){
if(this.wenzhendan[index].options[inde].select==''){
this.$toastMsg("请填写选项");
return
}
console.log('初始前',this.wenzhendan)
this.wenzhendan[index].options.push(
{
select:'',
}
);

$("#textBtn").focus();
},
removeQuestion(i){
if(i >= 1){
this.wenzhendan.splice(i,1);
}else{
this.$toastMsg("不能删除第一题");
};

$("#textBtn").focus();
},
removeSelect(i,j){
if(j >= 1){
this.wenzhendan[i].options.splice(j,1);
}else{
this.$toastMsg("不能删除第一个选项");
}
},

addAddress(){
if(this.inquiryname==''||this.inquiryname==null){
this.$toastMsg("请输入随访单/问诊单名称");
return;
}




for(var i=0;i<this.wenzhendan.length;i++){
if(this.wenzhendan[i].questionname==''||this.wenzhendan[i].questionname==null){
this.$toastMsg("第"+(i+1)+"个题的题目未填写");
return;
}if( this.wenzhendan[i].singleselection!='3'){
for(var k=0;k<this.wenzhendan[i].options.length;k++){
if(
this.wenzhendan[i].options.length<2&&this.wenzhendan[i].singleselection!=3
){
this.$toastMsg("第"+(i+1)+"个选择题的选项小于两个。");
return;
}
if(
this.wenzhendan[i].singleselection!=3&&(this.wenzhendan[i].options[k].select==''||this.wenzhendan[i].options[k].select==null)
){
this.$toastMsg("第"+(i+1)+"个题的题目的第"+(k+1)+"个选项未填写。");
return;
}
}
}

}
if(this.operate=='add'){
var _this=this;
var data = {
inquiryname:_this.inquiryname,
doctorId:this.$route.query.doctorId,
inquiryType:_this.type=='WZ'?'1':'2',//问诊单1 随访单2
type:'2', //1普通 2有医生id
questionOptions: _this.wenzhendan,
isDefault:_this.defaultValue,
};
this.$doRequest("/api/inquirytempletinfo/createTemplate", data, res => {
_this.$toastMsg("提交成功");
const u = navigator.userAgent;
const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
if (isiOS) {

window.webkit.messageHandlers.JAMS__mark.postMessage('1')
} else {
window.JAMS__make.closewindosws();


}
});
}else {
var _this=this;
var data = {
id:this.$route.query.id,
inquiryname:_this.inquiryname,
doctorId:this.$route.query.doctorId,
inquiryType:_this.type=='WZ'?'1':'2',//问诊单1 随访单2
type:'2', //1普通 2有医生id
questionOptions: _this.wenzhendan,
isDefault:_this.defaultValue,
};
this.$doRequest("/api/inquirytempletinfo/updateinquiryTemplate", data, res => {
_this.$toastMsg("修改成功");
const u = navigator.userAgent;
const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
if (isiOS) {

window.webkit.messageHandlers.JAMS__mark.postMessage('1')
} else {
window.JAMS__make.closewindosws();


}

});
}

},
query1() {
if(true){
var _this = this;
var data = {
parameters:_this.$route.query.doctorId?_this.$route.query.doctorId:'',//医生id
parametersone:_this.$route.query.type?_this.$route.query.type:'', //1问诊2随访
};
this.$doRequest("/api/inquirytempletinfo/doctorGetInquiryTemplaterInfo", data, res => {
});
}
},

query() {
this.showLoading = true;
var _this = this;
if(_this.operate!='add'){
var data={
parameters:_this.$route.query.id, //模板id
};
}else if(
_this.operate=='add' && _this.type=='WZ'
){
var data = {
parameters:'d7ed8c11ea8b270050568813bd', //模板id
};
}else if(
_this.operate=='add' && _this.type=='SF'
){
var data = {
parameters:'d3edb311ea8b270050568813bd', //模板id
};
}
this.$doRequest("/api/inquirytempletinfo/getInquiryTemplateDetail", data, res => {
_this.showLoading = false;
for(var i=0;i<res.parameters.questionOptions.length;i++){
if(
res.parameters.questionOptions[i].singleselection
){
res.parameters.questionOptions[i].singleselection=res.parameters.questionOptions[i].singleselection.toString();
if(res.parameters.questionOptions[i].singleselection=='3'){
res.parameters.questionOptions[i].options=[{
select:''
}]
}
}
if(res.parameters.questionOptions[i].isrequired
){
res.parameters.questionOptions[i].isrequired=res.parameters.questionOptions[i].isrequired.toString();
}
};
if(_this.operate=='inquiry'){
_this.inquiryname = res.parameters.inquiryname;
}

_this.wenzhendan = res.parameters.questionOptions;
_this.defaultValue = res.parameters.isDefault;

});
},


reset(){
var _this=this;
if(
_this.type=='WZ'
){
var data = {
parameters:'d7ed8c11ea8b270050568813bd', //模板id
};
}else if(
_this.type=='SF'
){
var data = {
parameters:'d3edb311ea8b270050568813bd', //模板id
};
}
this.$doRequest("/api/inquirytempletinfo/getInquiryTemplateDetail", data, res => {
for(var i=0;i<res.parameters.questionOptions.length;i++){
if(
res.parameters.questionOptions[i].singleselection
){
res.parameters.questionOptions[i].singleselection=res.parameters.questionOptions[i].singleselection.toString();
if(res.parameters.questionOptions[i].singleselection=='3'){
res.parameters.questionOptions[i].options=[{
select:''
}]
}
}
if(res.parameters.questionOptions[i].isrequired
){
res.parameters.questionOptions[i].isrequired=res.parameters.questionOptions[i].isrequired.toString();
}
};
_this.wenzhendan = res.parameters.questionOptions;
_this.defaultValue = res.parameters.isDefault;

});
},
clear(){
this.wenzhendan=[
{
singleselection:'2',
isrequired:'1',

questionname:'',
options:[{
select:'',
}]
}
]
}
},


}



// WEBPACK FOOTER //
// ./src/views/upload/five/five.vue